import { BaseApi } from '@/core/api/base.api'
import { Room } from '@/core/api/room.api'
import { RoomUser } from '@/core/api/room.user.api';
import { roomChatService } from '@/core/service/room.chat.service';

class RoomChatApi extends BaseApi {
  #chatHistoryList = [];
  
  constructor() {
    super()
    Room.Chat = this

    Room.ready(async e => {
      this._eventListen(this.#Events)
    })
  }

  #Events = {
    room_chat_text(e) {
      this.addChatsHistory(e);
      Room.emit(e);
    },
    // room_chat_emoticon(e) {
    //   this.addChatsHistory(e);
    //   Room.emit(e);
    // },
    // room_chat_share_start(e) {
    //   Room.emit(e);
    // },
    // room_chat_share_end(e) {
    //   Room.emit(e);
    // },
  }

  // addMyChat(text) {
  //   Room.emit({type: 'add_my_chat', text});    
  // }
  //
  // addMyEmotion(src) {
  //   Room.emit({type: 'add_my_emoticon', src});
  // }
  
  addChatsHistory(e){
    let roomUser= RoomUser.getRoomUser(e.userId);
    this.#chatHistoryList.push({...e, roomUser});
  }
  getChatsHistoryList(data){
    let {count} = data || {};
    return Object.freeze([...this.#chatHistoryList.slice(-count)]);
  }
  
  
  async sendChatMessage(data) {
    const { mentionList } = data;

    if (!mentionList || !mentionList.length) {
      delete data.mentionList;
    }

    await roomChatService.sendChatMessage(data)
  }

  async sendChatEmoticon(data) {
    await roomChatService.sendChatEmoticon(data)
  }

  async startShareChat(data) {
    return await roomChatService.startShareChat(data);
  }

  async endShareChat(data) {
    await roomChatService.endShareChat(data);
  }
}

export const RoomChat = new RoomChatApi()
